import React, { useState } from "react";
import { Polyline } from "react-leaflet";
import  polyUtil  from "polyline-encoded";
import { navigateToDetail } from "../Utils/utils";

export const Routing = (props) => {
  const { route, redirectRoute, isOverview } = props

  const [pathOptions, setPathOptions] = useState({color: `${route.routeColor}`})
  
  const decoder = (route) => {
    const decoded = polyUtil.decode(route, 5);
    return decoded;
  }

  const handleMouseOver = () => {
    setPathOptions({color: `${route.routeColor}`, weight: 6})
  }

  const handleMouseOut = () => {
    setPathOptions({color: `${route.routeColor}`, weight: 3})
  }

  return(
    <Polyline
    key={route.id}
    pathOptions={pathOptions}
    positions={decoder(route.routing)}
    eventHandlers={{
      click: (e) => {
        navigateToDetail(route.id, window, redirectRoute);
      },
      mouseover: handleMouseOver,
      mouseout: handleMouseOut,
    }}
  />
  );
}

export default Routing;